import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=6aee8020&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=6aee8020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee8020",
  null
  
)

export default component.exports